import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  dialogWrapper: {
    height: '80vh'
  },
  codeWrapper: {
    overflowY: 'auto',
    maxHeight: '75vh'
  }
}))
